import request from "@/api/request";

export default {
    // 统计
    result: async data => request({ url: '/console/basic.Index/index', data }),

    // 通知
    getList: async data => request({ url: '/console/basic.Notify/getList', data }),

    // 修改手机号判断（第一步）
    changePhone: async data => request({ url: '/console/basic.Index/changePhone', data }),
    
    // 修改手机号提交（第二步）
    changeNewPhone: async data => request({ url: '/console/basic.Index/changeNewPhone', data }),
}
